import React from 'react';
import { BookOpen, Sparkles, ArrowRight } from 'lucide-react';

const ServiceCards = ({ setActiveSection }) => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-emerald-600 to-blue-600 bg-clip-text text-transparent">
              Our Services
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Choose from our comprehensive range of solutions designed for your success
          </p>
        </div>
        
        <div className="flex justify-center max-w-5xl mx-auto">
          {/* A.G.O Learn & Earn Card */}
          <div 
            onClick={() => setActiveSection('learn')} 
            className="group relative bg-gradient-to-br from-blue-50 to-purple-100 p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer border border-blue-200 hover:border-blue-300 transform hover:scale-105 overflow-hidden max-w-sm w-full"
          >
            
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-300 rounded-full -translate-y-16 translate-x-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-purple-400 rounded-full translate-y-12 -translate-x-12"></div>
            </div>
            
            <div className="relative">
              {/* Icon with Glow Effect */}
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-blue-400 rounded-2xl blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-300"></div>
                <div className="relative w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
                  <BookOpen className="text-white" size={32} />
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-700 transition-colors">
                A.G.O Learn & Earn
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Upskilling and income opportunities designed for students and professionals seeking growth
              </p>
              
              {/* Features List */}
              <div className="space-y-2 mb-6">
                <div className="flex items-center text-sm text-blue-700">
                  <Sparkles className="w-4 h-4 mr-2" />
                  <span>Flexible learning schedules</span>
                </div>
                <div className="flex items-center text-sm text-blue-700">
                  <Sparkles className="w-4 h-4 mr-2" />
                  <span>Practical earning opportunities</span>
                </div>
                <div className="flex items-center text-sm text-blue-700">
                  <Sparkles className="w-4 h-4 mr-2" />
                  <span>Community-driven environment</span>
                </div>
              </div>
              
              <div className="flex items-center text-blue-600 font-semibold group-hover:text-blue-700 transition-colors">
                <span>Learn more</span>
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;